/* CVR 25/10 — clips produit muets en boucle (galerie + récit). Zéro octet vidéo au chargement :
   - récit : `data-src` posé seulement à l'approche de l'écran, lecture quand visible, pause sinon ;
   - galerie : lecture quand son slot est affiché (vignette, swipe ou changement de variante), pause sinon. */
(function () {
  var vids = document.querySelectorAll('video[data-pr-autovideo]');
  if (!vids.length) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function play(v) {
    if (v.dataset.src && !v.src) { v.src = v.dataset.src; v.preload = 'auto'; }
    if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }
  function shown(v) { var s = v.closest('[data-slot]'); return !s || !s.classList.contains('hidden'); }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { (e.isIntersecting && shown(e.target)) ? play(e.target) : e.target.pause(); });
  }, { rootMargin: '300px 0px' });
  vids.forEach(function (v) {
    io.observe(v);
    var slot = v.closest('[data-slot]');
    if (slot) new MutationObserver(function () {
      if (shown(v)) play(v); else v.pause();
    }).observe(slot, { attributes: true, attributeFilter: ['class'] });
  });
})();
